export const API_ROUTES = {
    HEALTH: '/api/v1/health',
    ANALYZE: '/api/v1/analyze',
    NOTES: '/api/v1/notes',
    NOTE: (id: string) => `/api/v1/notes/${id}` as const,
    NOTE_APPEND: (id: string) => `/api/v1/notes/${id}/append` as const,
    CATEGORIES: '/api/v1/categories',
    CATEGORY: (id: string) => `/api/v1/categories/${id}` as const,
    USER: '/api/v1/user',
    PROFILES: '/api/v1/profiles',
    PREFERENCES: '/api/v1/preferences',
} as const;
